module.exports = __webpack_public_path__ + "static/clutter-e51374bd250884a484e52155dd38b7be.jpg";